import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 pt-16">
      <div className="text-center px-4">
        <h1 className="text-8xl md:text-9xl font-black font-heading text-background-200 select-none mb-4">
          404
        </h1>
        <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
          页面未找到
        </h2>
        <p className="text-sm text-foreground-500 mb-8">
          您访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          <span>返回首页</span>
        </Link>
      </div>
    </div>
  );
}